export default "__VITE_ASSET__2192dd0c__"